export enum ButtonTypeEnum {
    Primary = 'primary',
    Secondary = 'secondary',
    Tertiary = 'tertiary',
    Destructive = 'destructive',
    IsIcon = 'isIcon'
}
